import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

export default function BrandMarquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="relative z-10 bg-primary-red py-5 border-y-2 border-black overflow-hidden" data-testid="marquee">
      <Marquee speed={70} gradient={false} autoFill>
        <span className="font-display uppercase text-3xl sm:text-4xl text-white mx-6 tracking-wide">
          {text}
        </span>
      </Marquee>
    </div>
  );
}
